import {
  Component,
  OnInit,
} from '@angular/core';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ProjectsService } from '../services/projects.service';
import { Router } from '@angular/router';

gsap.registerPlugin(ScrollTrigger);

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  data: any = [];
  loaded = false;


  constructor(private projectService: ProjectsService, private router: Router) {
  }

  animate() {
      gsap.to(".client", {
        ease: "none",
        scrollTrigger: {
          trigger: ".client",
          pin: true,
          scrub: 1
        }
      });
  }


  ngOnInit() {

    this.projectService.getProjects().subscribe(data => {
      this.data = data;
      this.loaded = true;


    var checkExist = setInterval(function() {
      if (document.querySelectorAll('.gallery').length) {

        var client_ele = document.querySelectorAll('.client');

        for(var i=0; i<=client_ele.length; i++){
          // var test_ele = document.querySelector(`#ele${i}`);
          gsap.set(client_ele[i], {x:0})
          if (i == 0){
            gsap.from(client_ele[i], {
              ease: "none",
              scrollTrigger: {
                trigger: ".u-image-1",
                scrub: 1,
                start: "200px top"
              },
              x: -100,
              opacity: 0.7
            });
          } else if (i%2 == 0){
            gsap.from(client_ele[i], {
              ease: "none",
              scrollTrigger: {
                trigger: client_ele[i-1],
                scrub: 1,
                start: "-100px top"
              },
              x: -100,
              // y: -100,
              // delay: 1,
              opacity: 0.7
            });
          } else {
            gsap.from(client_ele[i], {
              ease: "none",
              scrollTrigger: {
                trigger: client_ele[i-1],
                scrub: 1,
                start: "-100px top"
              },
              x: 100,
              // y: -100,
              // delay: 1,
              opacity:0.7
            });
          }


        }

        var heading = document.querySelector(".heading");

        gsap.from(heading,{
          scrollTrigger: {
            trigger:"body"
          },
          opacity:0,
          ease: "none",
          duration:1
        })

        var galDesc = document.querySelector(".gallery__desc");

        gsap.from(galDesc,{
          scrollTrigger: {
            trigger:"body"
          },
          y:100,
          opacity:0,
          ease: "none",
          duration:1
        })


         clearInterval(checkExist);
      }
   }, 100);

  });
  
  }


  naviagate(id: any) {
    this.router.navigate(['work', id]);
  }

}
